import { render } from "./DownLoadPage.vue?vue&type=template&id=52b6eb20&scoped=true"
import script from "./DownLoadPage.vue?vue&type=script&lang=js"
export * from "./DownLoadPage.vue?vue&type=script&lang=js"

import "./DownLoadPage.vue?vue&type=style&index=0&id=52b6eb20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b6eb20"]])

export default __exports__